export default "__VITE_ASSET__47f34241__"